const responsiveImage = () => {
  $('img').each(function () {
    const img = $(this);
    if (img.attr('data-desktop-src') && img.attr('data-mobile-src')) {
      if ($(window).width() > 667) {
        img.attr('src', img.attr('data-desktop-src'));
      } else {
        img.attr('src', img.attr('data-mobile-src'));
      }
    } else if (img.attr('data-desktop-src') === '' && img.attr('data-mobile-src')) {
      if ($(window).width() > 667) {
        $(this).parents('.hero').css('background', $(this).parents('.hero').attr('data-theme'));
      } else {
        img.attr('src', img.attr('data-mobile-src'));
      }
    } else if (img.attr('data-mobile-src') === '' && img.attr('data-desktop-src') === '') {
      $(this).parents('.hero').css('background', $(this).parents('.hero').attr('data-theme'));
    } else {
      const imgSrc = img.attr('data-mobile-src') || img.attr('data-desktop-src');
      img.attr('src', imgSrc);
    }
  });
};

export default responsiveImage;
